import VueLoader from '../../../default/vue-loader'

import NavCart from './nav_cart'

export default {

  addCartToNavbar() {
    return VueLoader.loadVueComponent(NavCart, document.getElementById('navCartForm'))
  }
}
